const defaultCurrencies = {
  ru: {
    RUB: "Рубль",
    TJS: "Сомони",
    USD: "Доллар",
    UZS: "Узбекский сум",
  },
  en: {
    RUB: "Rubl",
    TJS: "Somoni",
    USD: "Dollar",
    UZS: "Uzbek sum",
  },
  tm: {
    RUB: "Rubl",
    TJS: "Somoni",
    USD: "Dollar",
    UZS: "Özbek sumy",
  },
};

export default defaultCurrencies;
